import { Container } from "pixi.js";
import { LoaderAnimation } from "../../../common/components/animations/LoaderAnimation";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { FixedSizeContainer } from "../../../common/components/FixedSizeContainer";

export class MonPaymentProcessingLoader extends Container {
    private uiContainer: Container;
    private loaderAnimation: LoaderAnimation;

    public constructor(commonResourcePackage: CommonResourcesPackage) {
        super();
        this.loaderAnimation = new LoaderAnimation(
            [
                commonResourcePackage.assets_common_ui_loading_coin_png,
                commonResourcePackage.assets_common_ui_loading_crawn_png,
                commonResourcePackage.assets_common_ui_loading_star_png
            ]
        );
        this.loaderAnimation.position.set(0, 0);
        this.uiContainer = new FixedSizeContainer(this.width, this.height);
        this.addChild(this.uiContainer);
        this.uiContainer.addChild(this.loaderAnimation);
        this.hide();
    }

    public show(): void {
        this.loaderAnimation.play();
        this.uiContainer.alpha = 1;
        this.eventMode = "dynamic";
    }

    public hide(): void {
        this.loaderAnimation.stop();
        this.uiContainer.alpha = 0;
        this.eventMode = "none";
    }

    public async autoShowHide<T>(operation: Promise<T>): Promise<T> {
        this.show();
        try {
            return await operation;
        }
        catch (e: unknown) {
            throw e;
        }
        finally {
            this.hide();
        }
    }
}
